import React from 'react'

import { menuTab } from '../../../../../../constants/constants'

import useOfficer from './useOfficer'
import useFolderAndTabStore from '../../../../../../stores/appFolderAndTab/appFolderAndTabStore'
import ProjectWithdrawPage from '../../../page/requestNewProject/projectWithdraw/projectWithdraw'
import VerifyDocumentProjectWithdrawREC1 from '../../../page/verifyDocumentProjectWithdraw/verifyDocumentProjectWithdrawREC1'
import VerifyDocumentProjectWithdrawREC2 from '../../../page/verifyDocumentProjectWithdraw/verifyDocumentProjectWithdrawREC2'
import ConfirmProjectWithdrawPage from '../../../page/confirmProjectWithdraw/confirmProjectWithdraw'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import useCheckPermission from '../../../../../../utilities/checkPermission'
import constSubmittedStep from '../../../../../../constants/submittedStep'

type officerViewProps = ReturnType<typeof useOfficer> & OfficerProps
const OfficerView: React.FC<officerViewProps> = (props) => {
    const { callbackSaveComplete } = props
    const folderAndTabStore = useFolderAndTabStore()
    const manageProjectStore = useManageProjectStore()
    const checkPermission = useCheckPermission()

    const renderPage = () => {
        const tabID = folderAndTabStore?.tabSelected?.id
        const REC = manageProjectStore?.projectData?.irbType

        let isNotDisableTestResult = false

        switch (REC) {
            case 1:
                switch (tabID) {
                    case menuTab.tab21.id:
                    case menuTab.tab25.id:
                        return <ProjectWithdrawPage />
                    case menuTab.tab1.id:
                        if (checkPermission.isUserChairman()) {
                            isNotDisableTestResult =
                                manageProjectStore?.projectData?.stepID === constSubmittedStep.confirmProjectWithdraw
                        }
                        return (
                            <VerifyDocumentProjectWithdrawREC1
                                onSaveComplete={callbackSaveComplete}
                                isNotDisableTestResult={isNotDisableTestResult}
                            />
                        )
                    case menuTab.tabConfirmProjectWithdraw.id:
                        return <ConfirmProjectWithdrawPage onSaveComplete={callbackSaveComplete} />
                    default:
                        return <></>
                }

            case 2:
                switch (tabID) {
                    case menuTab.tab21.id:
                    case menuTab.tab25.id:
                        return <ProjectWithdrawPage />
                    case menuTab.tab1.id:
                        if (checkPermission.isUserChairman()) {
                            isNotDisableTestResult =
                                manageProjectStore?.projectData?.stepID === constSubmittedStep.confirmProjectWithdraw
                        }
                        return (
                            <VerifyDocumentProjectWithdrawREC2
                                onSaveComplete={callbackSaveComplete}
                                isNotDisableTestResult={isNotDisableTestResult}
                            />
                        )
                    case menuTab.tabConfirmProjectWithdraw.id:
                        return <ConfirmProjectWithdrawPage onSaveComplete={callbackSaveComplete} />
                    default:
                        return <></>
                }
            default:
                return <div></div>
        }
    }
    return renderPage()
}

type OfficerProps = {
    projectMode: 'CREATE' | 'EDIT'
    callbackSaveComplete?: (status: number, isDraft: boolean) => void
}
const Officer: React.FC<OfficerProps> = (props) => {
    const officerModel = useOfficer()
    return <OfficerView {...officerModel} {...props} />
}

export default Officer
